import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { listNotes, createNote, updateNote, deleteNote } from "./notes";

const Ctx = createContext(null);

export const NotesProvider = ({ children }) => {
  const [notes, setNotes] = useState([]);
  const reload = useCallback(() => listNotes().then(setNotes).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  const save = useCallback(async (note, id) => {
    try {
      const saved = id ? await updateNote(id, note) : await createNote(note);
      setNotes((ns) => [saved, ...ns.filter((n) => n.id !== saved.id)].sort((a, b) => b.start.localeCompare(a.start)));
      toast.success(id ? "Note updated" : "Note added");
      return true;
    } catch (e) {
      toast.error(e.response?.data?.detail?.toString?.() || "Could not save note");
      return false;
    }
  }, []);
  const remove = useCallback(async (id) => {
    try { await deleteNote(id); setNotes((ns) => ns.filter((n) => n.id !== id)); toast.success("Note deleted"); } catch { toast.error("Could not delete note"); }
  }, []);
  return <Ctx.Provider value={{ notes, save, remove, reload }}>{children}</Ctx.Provider>;
};

export const useNotes = () => useContext(Ctx);
